import { Theme, ThemeProvider, useTheme } from "@emotion/react";

import { navAccent, navIconBg } from "./navConstants";

type Props = {
  children: React.ReactNode;
};

export const NavAccentThemeScope: React.FC<Props> = ({ children }) => {
  const theme = useTheme();
  const scopedTheme: Theme = {
    ...theme,
    colors: {
      ...theme.colors,
      primary: navAccent,
      primaryLight: navIconBg,
    },
  };

  return <ThemeProvider theme={scopedTheme}>{children}</ThemeProvider>;
};
